// ============================================================================
// CONTACT Page
// Highlighted Social Media Links (Instagram & Facebook) & Info
// ============================================================================

import React from 'react';
import './styles/Contact.css';

function Contact() {
  const instagramUrl = "https://www.instagram.com/kittykeyn/";
  const facebookUrl = "https://www.facebook.com/profile.php?id=61571478706126";
  const tiktokUrl = "https://www.tiktok.com/@kittyfinds444";

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <div className="contact-eyebrow">✦ Connect With Us</div>
        <h1>Get in Touch 💌</h1>
        <p className="contact-subtitle">
          We’d love to hear from you! For commission requests, inquiries, and custom orders,
          reach out directly through our social channels.
        </p>
      </div>

      <div className="contact-container">
        {/* Highlighted Social Channels */}
        <div className="highlighted-socials">
          {/* Instagram Highlight Card */}
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-card social-card-instagram"
            aria-label="Visit our Instagram"
          >
            <div className="social-card-badge">✨ Most Active</div>
            <div className="social-card-icon">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </div>
            <div className="social-card-content">
              <h3>Instagram</h3>
              <p className="social-handle">@kittykeyn</p>
              <p className="social-desc">
                Follow us for drop announcements, commission previews, and send us a DM anytime.
              </p>
            </div>
            <span className="social-cta-btn">
              Open Instagram ↗
            </span>
          </a>

          {/* Facebook Highlight Card */}
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-card social-card-facebook"
            aria-label="Visit our Facebook"
          >
            <div className="social-card-badge">💬 Fast Response</div>
            <div className="social-card-icon">
              <svg width="34" height="34" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </div>
            <div className="social-card-content">
              <h3>Facebook</h3>
              <p className="social-handle">Kitty's Finds</p>
              <p className="social-desc">
                Chat with us on Messenger for quick questions, order tracking, and custom design requests.
              </p>
            </div>
            <span className="social-cta-btn">
              Message on Facebook ↗
            </span>
          </a>
        </div>

        {/* Additional Contact Info */}
        <div className="contact-secondary-grid">
          <div className="contact-mini-card">
            <div className="mini-card-icon">📧</div>
            <h4>Email Inquiries</h4>
            <a href="mailto:support@kittysfinds.com" className="mini-card-link">
              support@kittysfinds.com
            </a>
            <p className="mini-card-sub">Response within 24 hours</p>
          </div>

          <div className="contact-mini-card">
            <div className="mini-card-icon">⏰</div>
            <h4>Business Hours</h4>
            <p className="mini-card-text">Mon – Fri: 9:00 AM – 6:00 PM</p>
            <p className="mini-card-sub">Sat – Sun: 10:00 AM – 4:00 PM</p>
          </div>

          <div className="contact-mini-card">
            <div className="mini-card-icon">🎵</div>
            <h4>TikTok Channel</h4>
            <a href={tiktokUrl} target="_blank" rel="noopener noreferrer" className="mini-card-link">
              @kittyfinds444 ↗
            </a>
            <p className="mini-card-sub">Try-on hauls & styling tips</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
